import { endPblOcAssistanceSession } from '@/api/pbl.api';
import { clearPblAssistance } from '@/utils/pblAssistance';

export const endAssistanceAfterCaseSubmission = async (sessionId: number): Promise<void> => {
  const response = await endPblOcAssistanceSession(sessionId);
  if (response.data?.success !== true) throw new Error('PBL assistance session was not ended.');
  clearPblAssistance();
};
